<div class="ddc-dic-container" matTooltip="Dictionary: {{ label }}">
  <mat-icon class="dic-container-icon">auto_stories</mat-icon>
  <span class="dic-container-text">{{ label }}</span>
</div>
